// extracted by mini-css-extract-plugin
module.exports = {"header":"ModalInfo_header__1tTxU","footer":"ModalInfo_footer__36jy8"};